import { render, staticRenderFns } from "./Accordion01.vue?vue&type=template&id=0124d167&"
import script from "./Accordion01.vue?vue&type=script&lang=js&"
export * from "./Accordion01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports